module.exports = __webpack_public_path__ + "img/lera-work-1.3ac65e72.webp";